export default "__VITE_ASSET__Blq4WQiz__"